import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAchInformationRpt, loadAchInformationRpt } from '../../../store/reports';
import { getFormatedNumber } from '../../../../services/appService';
import GeneratePdf from '../../../../components/GeneratePdf';
import GenerateExcel from '../../../../components/GenerateExcel';

const AchInformation = (props) => {
    const [parterAchReports, setPartnerReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [excelShowHide, setExcelShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [selectedAchType, setSelectedAchType] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    // Copy coordinates state
    const [copiedText, setCopiedText] = useState("");
    const [tableSearchTerm, setTableSearchTerm] = useState("");

    // Dual Scrollbars Synchronization
    const [tableWidth, setTableWidth] = useState(0);
    const topScrollRef = useRef(null);
    const tableWrapperRef = useRef(null);

    const handleTopScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
    };

    const handleTableScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
        }
    };

    const achTypes = [
        { id: 1, name: "Sub-Contractors", pmId: 3 },
        { id: 2, name: "Recruiters", pmId: 5 },
        { id: 3, name: "W2 Candidates", pmId: 69 },
        { id: 4, name: "1099 Candidates", pmId: 70 },
    ];

    const achInformationRptSelector = useSelector(getAchInformationRpt);
    const dispatch = useDispatch();

    useEffect(() => {
        // Only settle loading when fresh API data arrives (not on type change alone)
        if (selectedAchType === 0) {
            setPartnerReports([]);
            return;
        }
        setPartnerReports(achInformationRptSelector || []);
        setIsLoading(false);
    }, [achInformationRptSelector]);

    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        setCopiedText(text);
        setTimeout(() => setCopiedText(""), 2000);
    };

    const handleAchTypeSelect = (pmId) => {
        if (isLoading || Number(selectedAchType) === pmId) return;
        setSelectedAchType(pmId);
        setPartnerReports([]);
        setIsLoading(true);
        dispatch(loadAchInformationRpt(pmId, 0, 0));
        setTableSearchTerm("");
    };

    const getFilteredReports = () => {
        if (!parterAchReports) return [];
        return parterAchReports.filter(item => {
            const term = tableSearchTerm.toLowerCase();
            const companyName = (item.name || "").toLowerCase();
            const keyName = (item.keyName || "").toLowerCase();
            const bankName = (item.bank || "").toLowerCase();
            const email = (item.email || "").toLowerCase();
            const keyEmail = (item.keyEmail || "").toLowerCase();
            const idVal = String(item.id || item.keyId || "").toLowerCase();

            return companyName.includes(term) ||
                keyName.includes(term) ||
                bankName.includes(term) ||
                email.includes(term) ||
                keyEmail.includes(term) ||
                idVal.includes(term);
        });
    };

    const filteredReports = getFilteredReports();

    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const updateWidth = () => {
            const table = document.getElementById("sub_ach_rpt");
            const wrapper = tableWrapperRef.current;
            if (table && wrapper) {
                setTableWidth(table.scrollWidth);
                setIsScrollable(table.scrollWidth > wrapper.clientWidth + 5);
            } else {
                setIsScrollable(false);
            }
        };

        updateWidth();
        const timer = setTimeout(updateWidth, 300);

        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
            clearTimeout(timer);
        };
    }, [filteredReports, selectedAchType]);

    // Stats calculations
    const getKpiStats = () => {
        if (!parterAchReports || parterAchReports.length === 0) {
            return { totalCount: 0, uniqueBanks: 0, checkingCount: 0, savingsCount: 0 };
        }
        const totalCount = parterAchReports.length;
        const uniqueBanks = new Set(
            parterAchReports
                .map((item) => (item.bank || "").trim().toLowerCase())
                .filter((b) => b !== "")
        ).size;
        const checkingCount = parterAchReports.filter((item) =>
            (item.accountType || "").toLowerCase().includes("checking")
        ).length;
        const savingsCount = parterAchReports.filter((item) =>
            (item.accountType || "").toLowerCase().includes("savings")
        ).length;

        return { totalCount, uniqueBanks, checkingCount, savingsCount };
    };

    const { totalCount, uniqueBanks, checkingCount, savingsCount } = getKpiStats();

    const subcontractorExportPDF = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Bank",
                "Routing #",
                "Account #",
                "Account Type",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        if (Number(selectedAchType) > 5) {
            headers = [
                [
                    "ID",
                    "Name",
                    "Email",
                    "Phone",
                    "Bank",
                    "Routing #",
                    "Account #",
                    "Account Type",
                ],
            ];
        }

        let data = [];
        filteredReports.map((item) =>
            Number(selectedAchType) > 5 ?
                data.push([
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType
                ]) :
                data.push([
                    item.id,
                    item.name,
                    item.email,
                    item.phone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType,
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone
                ])
        );
        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);
    };

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const subcontractorExportExcel = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Bank",
                "Routing #",
                "Account #",
                "Account Type",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        if (Number(selectedAchType) > 5) {
            headers = [
                [
                    "ID",
                    "Name",
                    "Email",
                    "Phone",
                    "Bank",
                    "Routing #",
                    "Account #",
                    "Account Type",
                ],
            ];
        }

        let data = [];
        filteredReports.forEach((item) =>
            Number(selectedAchType) > 5 ?
                data.push([
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType
                ]) :
                data.push([
                    item.id,
                    item.name,
                    item.email,
                    item.phone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType,
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone
                ])
        );
        setSelectedCol(headers);
        setSelectedColData(data);
        setExcelShowHide(true);
    };

    const handleexcelShowHide = () => {
        setExcelShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const renderClipboardIcon = (val) => {
        if (!val) return null;
        return copiedText === val ? (
            <i className="fa fa-check text-success ach-copy-btn" title="Copied!"></i>
        ) : (
            <i
                className="fa fa-clipboard ach-copy-btn"
                title="Copy coordinates"
                onClick={() => copyToClipboard(val)}
            ></i>
        );
    };

    return (
        <div className="ach-report-container">
            <style>{`
                .ach-report-container {
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    color: #1e293b;
                    margin-bottom: 2rem;
                }

                /* Visual selector cards */
                .ach-card-selector {
                    margin-bottom: 14px;
                }

                .ach-select-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 13px 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                    height: 100%;
                    position: relative;
                }

                .ach-select-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.06);
                    border-color: #cbd5e1;
                }

                .ach-select-card.active {
                    background: #ffffff !important;
                    border: 1.5px solid #171717 !important;
                    box-shadow: 0 6px 18px -4px rgba(15, 23, 42, 0.08), inset 4px 0 0 0 #171717 !important;
                }

                .ach-select-card.active .ach-select-card-title {
                    color: #1e293b !important;
                    font-weight: 500 !important;
                }

                .ach-select-card.active .ach-select-card-desc {
                    color: #525252 !important;
                }

                .ach-select-card-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 0 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    flex-shrink: 0;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    transition: all 0.2s ease;
                }

                .ach-select-card.active .ach-select-card-icon {
                    background: #171717 !important;
                    color: #ffffff !important;
                    border-color: #171717 !important;
                }

                .ach-card-check-badge {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 18px;
                    height: 18px;
                    border-radius: 0 !important;
                    background: #171717;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    animation: badgePop 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                }

                @keyframes badgePop {
                    from { transform: scale(0.6); opacity: 0; }
                    to   { transform: scale(1); opacity: 1; }
                }

                .ach-select-card:hover .ach-select-card-icon {
                    transform: scale(1.05);
                }

                .ach-select-card.loading {
                    pointer-events: none;
                    opacity: 0.7;
                }

                .ach-loading-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    margin-right: 10px;
                }

                .ach-loading-status i {
                    color: #1e293b;
                }

                .ach-select-card-title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #1e293b;
                    margin-bottom: 2px;
                }

                .ach-select-card-desc {
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    line-height: 1.3;
                }

                /* KPI Metric display cards */
                .ach-kpi-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
                    gap: 16px;
                    margin-bottom: 14px;
                }

                .ach-metric-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 14px 18px;
                    display: flex;
                    align-items: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
                }

                .ach-metric-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 0 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    margin-right: 14px;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    flex-shrink: 0;
                }

                .ach-metric-val {
                    font-size: 18px;
                    font-weight: 500;
                    color: #1e293b;
                    line-height: 1.1;
                    margin-bottom: 2px;
                }

                .ach-metric-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.02em;
                }

                /* Controls layout */
                .ach-report-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 1rem;
                    margin-bottom: 14px;
                    background-color: #fafbfc;
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    padding: 14px 18px;
                }

                .ach-search-wrapper {
                    position: relative;
                    width: 320px;
                }

                .ach-search-input {
                    width: 100%;
                    padding: 8px 12px 8px 34px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 0 !important;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1e293b;
                    transition: all 0.2s ease;
                }

                .ach-search-input:focus {
                    outline: none;
                    border-color: #171717;
                    box-shadow: 0 0 0 3px rgba(23, 23, 23, 0.1);
                }

                .ach-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 12px;
                }

                .ach-actions-btns {
                    display: flex;
                    align-items: center;
                }

                .ach-actions-btns > * {
                    margin-right: 8px !important;
                }

                .ach-actions-btns > *:last-child {
                    margin-right: 0 !important;
                }

                .ach-report-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 7px 14px;
                    height: 35px !important;
                    min-height: 35px !important;
                    box-sizing: border-box !important;
                    border-radius: 0 !important;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #1e293b;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .ach-report-btn:hover:not(:disabled) {
                    background-color: #f5f5f5;
                    color: #1e293b;
                    border-color: #94a3b8;
                }

                .ach-report-btn-secondary {
                    background-color: #ffffff;
                }

                .ach-report-btn:disabled {
                    background-color: #ffffff !important;
                    border-color: #cbd5e1 !important;
                    color: #94a3b8 !important;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                    cursor: not-allowed;
                }

                /* Table modifications matching WorkflowUser */
                .ach-report-table-wrapper {
                    border: 1px solid #e2e8f0;
                    border-radius: 0 !important;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.01);
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar {
                    height: 6px !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-track {
                    background: #f1f5f9 !important;
                    border-radius: 0 !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                    border-radius: 0 !important;
                }

                .ach-top-scrollbar-wrap::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(180deg, #64748b, #94a3b8) !important;
                }

                .ach-report-table-wrapper::-webkit-scrollbar,
                .ach-report-body div::-webkit-scrollbar {
                    width: 6px !important;
                    height: 6px !important;
                }

                .ach-report-table-wrapper::-webkit-scrollbar-track,
                .ach-report-body div::-webkit-scrollbar-track {
                    background: transparent !important;
                }

                .ach-report-table-wrapper::-webkit-scrollbar-thumb,
                .ach-report-body div::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                    border-radius: 0 !important;
                    transition: all 0.2s ease !important;
                }

                .ach-report-table-wrapper::-webkit-scrollbar-thumb:hover,
                .ach-report-body div::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(180deg, #64748b, #94a3b8) !important;
                }

                .ach-report-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                    text-align: left;
                }

                .ach-report-table thead {
                    background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                }

                .ach-report-table thead tr {
                    background: transparent !important;
                }

                .ach-report-table th {
                    background: transparent !important;
                    background-color: transparent !important;
                    color: #64748b !important;
                    font-weight: 600 !important;
                    font-size: 12px !important;
                    text-transform: uppercase !important;
                    letter-spacing: 0.6px !important;
                    padding: 13px 16px !important;
                    border-bottom: 2px solid #e2e8f0 !important;
                    border-top: none !important;
                    border-left: none !important;
                    border-right: none !important;
                    white-space: nowrap !important;
                }

                .ach-report-table tbody tr {
                    transition: background 0.15s ease, box-shadow 0.15s ease !important;
                }

                .ach-report-table tbody tr:hover {
                    background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
                    box-shadow: inset 3px 0 0 0 #171717 !important;
                }

                .ach-report-table tbody tr:hover td {
                    color: #1e293b !important;
                }

                .ach-report-table td {
                    padding: 13px 16px !important;
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    color: #1e293b !important;
                    border-bottom: 1px solid #f1f5f9 !important;
                    vertical-align: middle !important;
                    transition: color 0.15s ease !important;
                    white-space: nowrap !important;
                }

                .ach-report-table tbody tr:last-child td {
                    border-bottom: none !important;
                }

                .ach-report-empty {
                    padding: 4rem 2rem;
                    text-align: center;
                    color: #94a3b8;
                    border: 2px dashed #e2e8f0;
                    border-radius: 0 !important;
                    background-color: #f8fafc;
                }

                .ach-copy-btn {
                    color: #94a3b8;
                    cursor: pointer;
                    margin-left: 6px;
                    transition: all 0.15s ease;
                    font-size: 12px;
                }

                .ach-copy-btn:hover {
                    color: #1e293b;
                }

                /* Shimmer and Loading Animation */
                @keyframes shimmer {
                  0%   { background-position: -600px 0; }
                  100% { background-position: 600px 0; }
                }

                @keyframes loadingBar {
                  0%   { width: 0%; opacity: 1; }
                  70%  { width: 85%; opacity: 1; }
                  100% { width: 100%; opacity: 0; }
                }

                .wf-loading-bar {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #171717, #737373, #171717);
                  background-size: 200% 100%;
                  animation: loadingBar 1.6s ease-in-out infinite;
                  z-index: 10;
                }

                .skeleton-cell {
                  display: block;
                  height: 12px;
                  border-radius: 0 !important;
                  background: linear-gradient(
                    90deg,
                    #f1f5f9 25%,
                    #e2e8f0 50%,
                    #f1f5f9 75%
                  );
                  background-size: 600px 100%;
                  animation: shimmer 1.4s ease-in-out infinite;
                }

                .skeleton-cell.sk-short  { width: 40%; }
                .skeleton-cell.sk-medium { width: 65%; }
                .skeleton-cell.sk-long   { width: 85%; }
                .skeleton-cell.sk-full   { width: 92%; }

                .skeleton-row td {
                  padding: 14px 16px !important;
                }

                /* Enhanced empty state */
                .wf-empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 50px 24px;
                  text-align: center;
                  gap: 12px;
                }

                .wf-roles-empty-state {
                  min-height: 250px;
                  width: 100%;
                }

                .wf-empty-icon {
                  width: 52px;
                  height: 52px;
                  border-radius: 0 !important;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 22px;
                  background: #f5f5f5;
                  border: 1px solid #d4d4d4;
                  color: #171717;
                  margin-bottom: 4px;
                }

                .wf-empty-title {
                  font-size: 14px;
                  font-weight: 500;
                  color: #1e293b;
                  margin: 0;
                  width: 100%;
                  text-align: center;
                }

                .wf-empty-desc {
                  font-size: 14px;
                  font-weight: 400;
                  color: #64748b;
                  margin: 0 auto;
                  line-height: 1.6;
                  text-align: center;
                  width: 100%;
                }
            `}</style>

            <div className="ach-card-selector">
                <div className="row">
                    {achTypes.map((t) => {
                        const isActive = Number(selectedAchType) === t.pmId;
                        const icons = {
                            3: "fa-handshake-o",
                            5: "fa-briefcase",
                            69: "fa-user",
                            70: "fa-user-circle-o"
                        };

                        return (
                            <div className="col-md-3 col-sm-6" key={t.id}>
                                <div
                                    className={`ach-select-card ${isActive ? "active" : ""} ${isLoading ? "loading" : ""}`}
                                    onClick={() => handleAchTypeSelect(t.pmId)}
                                >
                                    {isActive && !isLoading && (
                                        <div className="ach-card-check-badge">
                                            <i className="fa fa-check"></i>
                                        </div>
                                    )}
                                    {isActive && isLoading && (
                                        <div className="ach-card-check-badge">
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </div>
                                    )}
                                    <div className="ach-select-card-icon">
                                        <i className={`fa ${isActive && isLoading ? "fa-spinner fa-spin" : icons[t.pmId]}`}></i>
                                    </div>
                                    <div className="ach-select-card-body" style={{ flexGrow: 1, minWidth: 0, paddingRight: isActive ? "14px" : "0" }}>
                                        <div className="ach-select-card-title">{t.name}</div>
                                        <div className="ach-select-card-desc">
                                            {t.pmId === 3 && "Subcontractor accounts"}
                                            {t.pmId === 5 && "Recruiter wire routing"}
                                            {t.pmId === 69 && "W2 candidate payroll"}
                                            {t.pmId === 70 && "1099 contractor logs"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="ach-report-body p-0">
                {selectedAchType !== 0 && (
                    <div className="ach-report-controls">
                        <div className="ach-search-wrapper">
                            <i className="fa fa-search ach-search-icon"></i>
                            <input
                                type="text"
                                placeholder="Search by name, email, or bank..."
                                className="ach-search-input"
                                value={tableSearchTerm}
                                onChange={(e) => setTableSearchTerm(e.target.value)}
                                disabled={isLoading || !parterAchReports?.length}
                            />
                        </div>

                        <div className="ach-actions-btns">
                            {isLoading && (
                                <div className="ach-loading-status">
                                    <i className="fa fa-spinner fa-spin"></i>
                                    <span>Loading ACH records...</span>
                                </div>
                            )}
                            <button
                                type="button"
                                className="ach-report-btn ach-report-btn-secondary"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={subcontractorExportExcel}
                            >
                                <i className="fa fa-file-excel-o" style={{ color: "#1e293b", marginRight: "6px" }}></i> Excel Export
                            </button>
                            <button
                                type="button"
                                className="ach-report-btn ach-report-btn-secondary"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={subcontractorExportPDF}
                            >
                                <i className="fa fa-file-pdf-o" style={{ color: "#1e293b", marginRight: "6px" }}></i>
                                Export PDF
                            </button>
                        </div>
                    </div>
                )}

                {selectedAchType !== 0 && parterAchReports && parterAchReports.length > 0 && (
                    <div className="ach-kpi-row" style={{ marginTop: "12px", marginBottom: "14px" }}>
                        <div className="ach-metric-card">
                            <div className="ach-metric-icon">
                                <i className="fa fa-users"></i>
                            </div>
                            <div>
                                <div className="ach-metric-val">{totalCount}</div>
                                <div className="ach-metric-label">Total Records</div>
                            </div>
                        </div>
                        <div className="ach-metric-card">
                            <div className="ach-metric-icon">
                                <i className="fa fa-university"></i>
                            </div>
                            <div>
                                <div className="ach-metric-val">{uniqueBanks}</div>
                                <div className="ach-metric-label">Unique Banks</div>
                            </div>
                        </div>
                        <div className="ach-metric-card">
                            <div className="ach-metric-icon">
                                <i className="fa fa-check-circle-o"></i>
                            </div>
                            <div>
                                <div className="ach-metric-val">{checkingCount}</div>
                                <div className="ach-metric-label">Checking Accts</div>
                            </div>
                        </div>
                        <div className="ach-metric-card">
                            <div className="ach-metric-icon">
                                <i className="fa fa-folder-o"></i>
                            </div>
                            <div>
                                <div className="ach-metric-val">{savingsCount}</div>
                                <div className="ach-metric-label">Savings Accts</div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Synchronized top scrollbar */}
                {parterAchReports && parterAchReports.length > 0 && filteredReports.length > 0 && isScrollable && (
                    <div
                        ref={topScrollRef}
                        onScroll={handleTopScroll}
                        className="ach-top-scrollbar-wrap"
                        style={{ overflowX: "auto", overflowY: "hidden", height: "8px", width: "100%", marginBottom: "2px" }}
                    >
                        <div style={{ width: `${tableWidth}px`, height: "1px" }}></div>
                    </div>
                )}

                <div
                    ref={tableWrapperRef}
                    onScroll={handleTableScroll}
                    className="table-responsive ach-report-table-wrapper"
                    style={{ position: "relative" }}
                >
                    {isLoading && <div className="wf-loading-bar" />}

                    {selectedAchType === 0 ? (
                        <div className="wf-empty-state">
                            <div className="wf-empty-icon">
                                <i className="fa fa-info-circle"></i>
                            </div>
                            <p className="wf-empty-title">No Category Selected</p>
                            <p className="wf-empty-desc">Select an entity category above to inspect ACH registry profiles.</p>
                        </div>
                    ) : isLoading ? (
                        /* SKELETON TABLE */
                        <table className="ach-report-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    {Number(selectedAchType) > 5 ? (
                                        <>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                        </>
                                    ) : (
                                        <>
                                            <th>Company Name</th>
                                            <th>Company Email</th>
                                            <th>Company Phone</th>
                                        </>
                                    )}
                                    <th>Bank</th>
                                    <th>Routing #</th>
                                    <th>Account #</th>
                                    <th>Account Type</th>
                                    {Number(selectedAchType) <= 5 && (
                                        <>
                                            <th>Key Contact ID</th>
                                            <th>Key Contact Name</th>
                                            <th>Key Contact Email</th>
                                            <th>Key Contact Phone</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <tr key={`skel-${i}`} className="skeleton-row">
                                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                        <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                        <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                        <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                        {Number(selectedAchType) <= 5 && (
                                            <>
                                                <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                                <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                                <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : parterAchReports && parterAchReports.length > 0 ? (
                        filteredReports.length > 0 ? (
                            <table
                                className="ach-report-table"
                                id="sub_ach_rpt"
                            >
                                {Number(selectedAchType) > 5 ? (
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Phone</th>
                                            <th>Bank</th>
                                            <th>Routing #</th>
                                            <th>Account #</th>
                                            <th>Account Type</th>
                                        </tr>
                                    </thead>
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Company Name</th>
                                            <th>Company Email</th>
                                            <th>Company Phone</th>
                                            <th>Bank</th>
                                            <th>Routing #</th>
                                            <th>Account #</th>
                                            <th>Account Type</th>
                                            <th>Key Contact ID</th>
                                            <th>Key Contact Name</th>
                                            <th>Key Contact Email</th>
                                            <th>Key Contact Phone</th>
                                        </tr>
                                    </thead>
                                )}

                                <tbody>
                                    {filteredReports.map((item, key) =>
                                        Number(selectedAchType) > 5 ? (
                                            <tr key={item.keyId || key}>
                                                <td>{item.keyId}</td>
                                                <td>{item.keyName}</td>
                                                <td>{item.keyEmail}</td>
                                                <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                <td>{item.bank}</td>
                                                <td>
                                                    <span>
                                                        {item.rounting}
                                                        {renderClipboardIcon(item.rounting)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>
                                                        {item.account}
                                                        {renderClipboardIcon(item.account)}
                                                    </span>
                                                </td>
                                                <td>{item.accountType}</td>
                                            </tr>
                                        ) : (
                                            <tr key={item.id || key}>
                                                <td>{item.id}</td>
                                                <td>{item.name}</td>
                                                <td>{item.email}</td>
                                                <td>{item.phone && getFormatedNumber(item.phone)}</td>
                                                <td>{item.bank}</td>
                                                <td>
                                                    <span>
                                                        {item.rounting}
                                                        {renderClipboardIcon(item.rounting)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span>
                                                        {item.account}
                                                        {renderClipboardIcon(item.account)}
                                                    </span>
                                                </td>
                                                <td>{item.accountType}</td>
                                                <td>{item.keyId}</td>
                                                <td>{item.keyName}</td>
                                                <td>{item.keyEmail}</td>
                                                <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        ) : (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-search"></i>
                                </div>
                                <p className="wf-empty-title">No Matching Records</p>
                                <p className="wf-empty-desc">No records matched your search query. Try adjusting your search term.</p>
                            </div>
                        )
                    ) : (
                        <div className="wf-empty-state">
                            <div className="wf-empty-icon">
                                <i className="fa fa-folder-open-o"></i>
                            </div>
                            <p className="wf-empty-title">No Data Found</p>
                            <p className="wf-empty-desc">No ACH details registered for this category on the server.</p>
                        </div>
                    )}
                </div>
            </div>

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
            <GenerateExcel
                handleexcelShowHide={handleexcelShowHide}
                excelShowHide={excelShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GenerateExcel>
        </div>
    );
};

export default AchInformation;